import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {emptyProductSheetObject,} from '../../interfaces/IProductSheet';
import {getProductsById} from '../../utility/FetchAPI';
import {SheetTable} from '../category/sheetPage/SheetTable';
import {useTranslation} from 'react-i18next';
import './QrOverview.css';
import moment from 'moment';
import {emptyProductObject} from '../../interfaces/IProduct';

export const QrOverview = () => {
    //Get data in Use Effect
    const [productSheet, setProductSheet] = useState(emptyProductSheetObject);
    const [sheetNumbers, setSheetNumbers]: any = useState([]);
    const [foundProductCollection] = useState([
        emptyProductObject,
    ]);
    const [isLoading, setIsLoading] = useState(true);
    const [linkedFluidCount, setLinkedFluidCount] = useState(0);
    const [unlinkedFluidCount, setUnlinkedFluidCount] = useState(0);
    const [showMore, setShowMore] = useState(false);
    const {productId} = useParams();
    const {t, i18n} = useTranslation();

    useEffect(() => {
        let numbers: string[] = [];
        let resultSheet = emptyProductSheetObject;
        getProductsById(productId!).then((result: any) => {
            console.log(
                '🚀 ~ file: qrOverview.tsx ~ line 33 ~ getProductsById ~ result.data[0]',
                result.data[0]
            );
            if (typeof result.data[0] !== 'undefined') {
                setProductSheet(result.data[0]);

                resultSheet = result.data[0];
                result.data.map((productSheet: any) => {
                    numbers.push(productSheet.sheetNumber);
                    numbers.sort((a, b) => (a < b ? -1 : 1));
                    setSheetNumbers(numbers);
                    let foundProducts = productSheet.productCollection.filter(
                        (product: any) => product.productId === productId
                    );
                    foundProductCollection.push(...foundProducts);
                });

                resultSheet.productCollection = [
                    foundProductCollection[foundProductCollection.length - 1],
                ];
                setProductSheet(resultSheet);
            }
            setIsLoading(false);
        });
    }, []);

    return (
        <div className='qrPage'>
            {!isLoading ? (
                <div>
                    {sheetNumbers.length < 1 ? (
                        <h2 className='textWhite wb-type-heading-l qrTitle'>
                            {t('ProductNotApproved')}
                        </h2>
                    ) : (
                        <div>
                            <h2 className='textWhite wb-type-heading-l qrTitle'>
                                {t('ProductApproval')}
                            </h2>

                            <div>
                                <div className='qrLinkColletion'>
                                    <p className='textWhite wb-type-copy-strong linkText'>
                                        {' '}
                                        {t('Category')}: {t(productSheet.category)}{' '}
                                    </p>
                                </div>
                                <div className='qrSheetCollection'>
                                    <span className='textWhite wb-type-label linkText'>{`${t('DTFRApprovalLabel')}: `}</span>
                                    {sheetNumbers.map((sheetNumber: string, index: number) => {
                                        return (
                                            <>
                                                {sheetNumbers.length > index + 1 ? (
                                                    <span className='textWhite wb-type-label linkText qrSheetNumbers'>{sheetNumber + ' / '}</span>) : (<span className='textWhite wb-type-label linkText qrSheetNumbers'>{sheetNumber}</span>
                                                )}
                                            </>
                                        );
                                    })}
                                </div>
                                <div className='qrTableContainer'>
                                    {productSheet.publishDate && (
                                        <p className='textWhite wb-type-label timeLabel'>
                                            {t('LastUpdate')}{' '}
                                            {moment(
                                                productSheet.publishDate,
                                                [
                                                    'DD.MM.YY',
                                                    'DD.MM.YYYY',
                                                    'DD.MM.YY, HH:mm',
                                                    'DD.MM.YYYY, HH:mm'
                                                ],
                                                true
                                            ).format(i18n.language === 'de' ? 'DD.MM.YYYY' : 'MM/DD/YYYY')}
                                        </p>
                                    )}
                                    <SheetTable
                                        sheet={productSheet}
                                        language={i18n.language}
                                        showMore={showMore} setLinkedFluidCount={setLinkedFluidCount}
                                        setUnlinkedFluidCount={setUnlinkedFluidCount} setShowMore={setShowMore}
                                    ></SheetTable>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            ) : (
                <div></div>
            )}
        </div>
    );
};
